// extracted by mini-css-extract-plugin
export var container = "_1q-0";
export var icon = "_1q-1";